module.exports = __webpack_public_path__ + "img/gkzkc.ad24742f.png";